define( 'lib/utils',[ 'jquery' ],
	function ( $ ) {

		'use strict';

		var utils = {};

		utils.isRTL = function () {

			return $( 'html' ).attr( 'dir' ) === 'rtl';
		};

		utils.isWindowsPhone = function () {

			return navigator.userAgent.match( /IEMobile/i ) !== null;
		};

		utils.language = function () {

			return $( 'html' ).attr( 'lang' ) === undefined ? 'en' : $( 'html' ).attr( 'lang' );
		};

		utils.breakpoint = function () {

			return ( $( 'html' ).attr( 'class' ).match( /breakpoint-([a-z]+)/ ) || [ '', 'l' ] )[ 1 ];
		};

		utils.canTransition = function () {

			return document.body.style.transition !== undefined;
		};

		utils.headerBarHeight = function () {

			return $( '[ data-m12-bar="true"]' ).height();
		};

		utils.fixedHeader = function () {

			return $( '[ data-m12-bar="true"]' ).attr( 'data-m12-bar-fixed' ) === 'true';
		};

		utils.isTouchDevice = function () {

			return 'ontouchstart' in document.documentElement;
		};

		utils.isDevice = function () {
			return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		};

		utils.parseFloatInput = function ( val ) {

			return parseFloat( val.replace( /[^0-9.]/g, '' ), 10 );
		};

		utils.uniqueID = function () {

			return '_' + Math.random().toString( 36 ).substr( 2, 9 );
		};

		utils.isNumber = function ( o ) {
			return typeof o === 'number' && isFinite( o );
		};

		utils.getParameterByName = function ( name ) {
			name = name.replace( /[\[]/, "\\[" ).replace( /[\]]/, "\\]" );
			var regex = new RegExp( "[\\?&]" + name + "=([^&#]*)" ),
				results = regex.exec( location.search );
			return results === null ? "" : decodeURIComponent( results[ 1 ].replace( /\+/g, " " ) );
		};

		utils.percentageRound = function ( val, precision ) {

			var rounded;

			precision = precision || 2;
			rounded = '' + Math.round( val * Math.pow( 10, precision ) ) / Math.pow( 10, precision );

			if ( !rounded.match( /\./ ) ) rounded = rounded + '.';

			while ( rounded.match( /\.([0-9]*)$/ )[ 1 ].length < precision ) rounded = rounded + '0';

			return rounded + '%';
		};

		utils.isMSIE = function () {

			var ua = window.navigator.userAgent;
			var msie = ua.indexOf( 'MSIE' );

			if ( msie > 0 || !!navigator.userAgent.match( /Trident.*rv\:11\./ ) ) {

				// If Internet Explorer
				return true;
			} else {

				// If another browser
				return false;
			}

			return false;
		};

		utils.isLessThanIE10 = function () {
			var out = this.isMSIE() && document.all && window.matchMedia === undefined;
			return out;
		};

		utils.isLessThanIE9 = function () {
			return this.isMSIE() && document.addEventListener === undefined;
		};

		return utils;
	} );

